<template lang="html">
    <div id="page__customers" class="center-panel">
        <md-content md-theme="white" v-loader-overlay="progress">
            <customer-menu></customer-menu>
            <sort-table
                v-bind:columns="tableColumns" v-model="customers" @refresh="getCustomers" 
                v-bind:per-page="perPage" v-bind:total="customersAmount" table-id="customers" link
                v-on:create="addCustomer" tableHeight="calc(100% - 48px)"
                v-bind:loadOnScroll="true"
            >
                <template slot="type" slot-scope="scope">
                    <span> {{ getType(scope.item.type) }}</span>
                </template>

                <template slot="inn" slot-scope="scope">
                    <span> {{ ((scope.item.inn) ? scope.item.inn : ( (scope.item.passport_number) ? scope.item.passport_number : '' )) }}</span>
                </template>

                <template slot="nds" slot-scope="scope">
                    <span> {{ (scope.item.nds && parseInt(scope.item.nds) === 1) ? 'Да' : 'Нет'}}</span>
                </template>

                <template slot="liquidated" slot-scope="scope">
                    <span> {{ (scope.item.liquidated && parseInt(scope.item.liquidated) === 1) ? 'Да' : 'Нет'}}</span>
                </template>

                <template slot="is_agent" slot-scope="scope">
                    <span v-if="scope.item.is_agent && parseInt(scope.item.is_agent) == 1"> Перевозчик</span>
                    <span v-else> Клиент</span>
                </template>

                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import CustomerMenu from './menu.vue'
    import SortTable    from "@/components/SortTable";
    import ZIconButton  from '@/components/ZIconButton.vue';
    export default {
        components: { CustomerMenu, SortTable, ZIconButton },
        data() {
            return {
                tableColumns: [
                    { label: 'Тип', field: 'type', sortable: true },
                    { label: 'Название/ФИО',       field: 'name', sortable: true },
                    { label: 'ИНН/Номер паспорта', field: 'inn',  sortable: true },
                    { label: 'Телефон', field: 'phone',   sortable: true },
                    { label: 'НДС', field: 'nds',      sortable: true },
                    { label: 'Тип', field: 'is_agent', sortable: true },
                    { label: 'Ликвидирован', field: 'liquidated', sortable: true },
                    { label: '', field: 'actions' },
                ],
                perPage: 50
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-customers-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Список контрагентов
             */
            customers() {
                return this.$store.state.customers.customers.map(customer => {
                    customer.routerLink = { name: 'Customer', params: { customer_id: customer.id }, query: this.$route.query };
                    return customer;
                });
            },
            /**
             * Количество контрагентов
             */
            customersAmount() {
                return this.$store.state.customers.customers_amount
            },
        },
        created() {
            this.$store.commit('setTitle', 'Клиенты');
        },
        watch: {
            '$route.name'(name) {
                if (name == 'Customers') this.$store.commit('setTitle', 'Клиенты');
            }
        },
        methods: {
            /**
             * Добавление контрагента
             */
            addCustomer() {
                this.$router.push({ name: 'Customer', params: {customer_id: 'new'}});
            },
            /**
             * Получение контрагента
             */
            getCustomers(page, count, orderBy, orderType, f, reload) {
                this.$store.commit('showProgressBar', 'get-customers-list');
                this.$store.dispatch('customers/getCustomers', {
                    page:       page,
                    order_by:   orderBy,
                    order_type: orderType,
                    count:  count,
                    filter: this.resolveQueryFilter(),
                    concat: !reload
                }).finally(() => this.$store.commit('hideProgressBar', 'get-customers-list'));
            },
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return null;
                let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: [], relation: [], condition: 'and'};
                
                if (filter.search) {
                    result.model = [
                        ['name', '%', filter.search], 'or',
                        ['inn',  '%', filter.search], 'or',
                        ['kpp',  '%', filter.search], 'or',
                        ['passport_number', '%', filter.search], 'or',
                        ['phone',  '%', filter.search], 'or',
                        ['email',  '%', filter.search],
                    ];
                } else {
                    if (parseInt(filter.nds)        >= 0) model.push(['nds',        '=', filter.nds]);
                    if (parseInt(filter.type)       >= 0) model.push(['type',       '=', filter.type]);
                    if (parseInt(filter.agent)      >= 0) model.push(['is_agent',   '=', filter.agent]);
                    if (parseInt(filter.liquidated) >= 0) model.push(['liquidated', '=', filter.liquidated]);

                    model.map((item, i) => {
                        result.model.push(item);
                        if (model[i+1]) result.model.push('and');
                    });
                }

                return result;
            },
            /**
             * Удаление контрагента
             */
            removeCustomer(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'get-customers-list');
                this.$store.dispatch('customers/deleteCustomer', id)
                    .then(() => this.$root.$emit('refresh-table', 'customers'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-customers-list'));
            },
            /**
             * Модальное окно с подтверждением удаления контрагента
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Удалить контрагента?', 'Внимание! Действие необратимо!', 
                    () => this.removeCustomer(id)
                );
            },
            /**
             * Возвращает аббревиатуру контрагента по id типа
             */
            getType(typeId) {
                let result = 'ЮЛ';
                switch (parseInt(typeId)) {
                    case 1: result = 'ЮЛ'; break;
                    case 2: result = 'ФЛ'; break;
                    case 3: result = 'ИП'; break;
                    default: result = 'ЮЛ';
                }
                return result;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Customers.vue?b86785d8